import styles from "./SidebarSkeleton.module.scss";

type Props = {
  menuOpened: boolean;
};

const SidebarSkeleton: React.FC<Props> = ({ menuOpened }) => {
  return (
    <div className={styles.sidebarSkeleton}>
      {Array.from({ length: 13 }).map((_, i) => (
        <div
          key={i}
          className={`${styles.menuItem} ${
            !menuOpened ? styles.collapsed : ""
          } skeleton`}
        >
          <div className={styles.left}>
            <div className={`${styles.icon} skeleton`} />
            {menuOpened && <div className={`${styles.text} skeleton`} />}
          </div>
        </div>
      ))}
      
    </div>
  );
};

export default SidebarSkeleton;
